import { createFileRoute } from '@tanstack/react-router'

import { DeleteAccountFlow } from '@/features/account-deletion/delete-account-flow'

export const Route = createFileRoute('/_authed/settings/delete-account')({
  component: DeleteAccountFlow,
})
